import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";

interface ChatActionButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  /** "outline" matches the Figma spec (white bg, purple border). "solid" is the filled purple primary variant. */
  variant?: "solid" | "outline";
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  className?: string;
}

export function ChatActionButton({
  children,
  onClick,
  variant = "outline",
  type = "button",
  disabled,
  className,
}: ChatActionButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "relative flex items-center justify-center rounded-[68px] px-6 py-3.5",
        textVariants.bodySmall,
        "font-medium whitespace-nowrap transition-opacity active:opacity-70 disabled:opacity-50",
        variant === "outline" && [
          "border border-[#620ad5] bg-white text-[#620ad5]",
          "shadow-[inset_0px_-12px_6px_0px_rgba(98,10,213,0.06)]",
        ],
        variant === "solid" && [
          "bg-[#620ad5] text-white",
          "shadow-[inset_0px_-12px_6px_0px_rgba(98,10,213,0.12)]",
        ],
        className,
      )}
    >
      {children}
    </button>
  );
}
